<template>
  <sticky-header-layout>
    <template #header>
      <div class="filter-container">
        <div class="filter-item">
          <span class="filter-title">Date:</span>
          <gx-date-range-select
            :date-range.sync="filter.dateRange"
            :disabled="isLoading"
            @selectedDateRange="handleSelectedDateRange"
          />
        </div>
      </div>
      <div class="action-container">
        <div class="button-container">
          <el-button
            :loading="isGeneratingCSV"
            type="warning"
            icon="el-icon-download"
            size="mini"
            @click="handleExportCSV"
          >
            Export CSV
          </el-button>
        </div>
      </div>
    </template>
  </sticky-header-layout>
</template>

<script>
import format from 'date-fns/format'
import { generatePrivateClientSalesCSV } from '../../api/reports'
import fileDownload from '../../utils/file-download'

export default {
  name: 'PrivateClientSalesReport',
  data() {
    return {
      filter: this.getDefaultFilter(),
      dateRangeOptions: [
        { value: 'lastSevenDays', label: 'Last 7 Days' },
        { value: 'thisWeek', label: 'This Week' },
        { value: 'lastWeek', label: 'Last Week' },
        { value: 'thisMonth', label: 'This Month' },
        { value: 'lastMonth', label: 'Last Month' },
        { value: 'lastThirtyDays', label: 'Last 30 Days' },
        { value: 'custom', label: 'Custom' },
      ],
      customDateRange: [],
      isLoading: false,
      isGeneratingCSV: false,
    }
  },
  methods: {
    getDefaultFilter() {
      return {
        dateRange: { value: 'thisMonth', label: 'This Month' },
      }
    },
    getPayload() {
      return {
        startDate: (this.customDateRange[0]) ? format(this.customDateRange[0], 'yyyy-MM-dd') : null,
        endDate: (this.customDateRange[1]) ? format(this.customDateRange[1], 'yyyy-MM-dd') : null,
      }
    },
    async handleExportCSV() {
      this.isGeneratingCSV = true
      const payload = this.getPayload()
      
      try {
        const response = await generatePrivateClientSalesCSV(payload)
        this.isGeneratingCSV = false

        fileDownload(response, 'private_client_sales.csv')
      } catch (error) {
        console.log(error)
        this.isGeneratingCSV = false
      }
    },
    handleSelectedDateRange(dateRange) {
      this.customDateRange = dateRange
    },
  },
}
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/view-base.scss";

section {
  .filter-item {
    margin: 3px 0;
    width: 100%;
    @include mobile {
      margin: 3px 5px;
      width: calc(100% / 3 - 10px);
    }
    @include tablet {
      width: calc(100% / 4 - 10px);
    }
    @include desktop {
      width: calc(100% / 6 - 10px);
    }
  }
  .data-picker-container {
    position: relative;
    // Make the hack button span the whole parent container.
    .absolute-view {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      opacity: 0;
    }
  }
}
</style>
